'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'

const WindowUserSync = (): null => {
  const { status, data } = useSession()

  const isAuthenticated =
    Boolean(data?.triplaAccessToken) &&
    Boolean(data?.smartclubAccessToken) &&
    status === 'authenticated'

  useEffect(() => {
    // While NextAuth is still loading the session, keep the server-injected
    // value intact. Overwriting with `false` here would cause a brief flash
    // of `false` for already-logged-in users on first paint.
    if (status === 'loading') return
    window.__USER__ = { isAuthenticated }
  }, [isAuthenticated, status])

  return null
}

export default WindowUserSync
